/** Datum aus Seminar-/Event-Freitext extrahieren (letzter Tag = Ablauf). */

const pad = (n: number) => String(n).padStart(2, '0');

/** Alle erkennbaren Kalendertage aus Freitext (DE oder ISO). */
export const extractDatesFromSeminarText = (dateText?: string | null): Date[] => {
    if (!dateText || typeof dateText !== 'string') return [];
    const text = dateText.trim();
    if (!text) return [];

    const dates: Date[] = [];

    // 15. + 16.11.2026  /  21 & 22.06.2026  /  21. & 22.06.2026
    const multiDaySameMonth = text.match(
        /(\d{1,2})\s*[.&+]?\s*(?:[+&]|und)\s*(\d{1,2})\.?\s*(\d{1,2})\.(\d{4})/i
    );
    if (multiDaySameMonth) {
        const [, d1, d2, month, year] = multiDaySameMonth;
        const m = Number(month) - 1;
        const y = Number(year);
        dates.push(new Date(y, m, Number(d1)));
        dates.push(new Date(y, m, Number(d2)));
    }

    // Klassisch: 20.7.2026 / 20.07.2026
    const deGlobal = text.matchAll(/(\d{1,2})\.(\d{1,2})\.(\d{4})/g);
    for (const m of deGlobal) {
        dates.push(new Date(Number(m[3]), Number(m[2]) - 1, Number(m[1])));
    }

    // ISO: 2026-07-20
    const isoGlobal = text.matchAll(/(\d{4})-(\d{2})-(\d{2})/g);
    for (const m of isoGlobal) {
        dates.push(new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])));
    }

    return dates.filter((d) => !isNaN(d.getTime())).map(
        (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate())
    );
};

/** Spätester Tag aus dem Freitext (= Seminar-Ende für Archivierung). */
export const parseSeminarEndDate = (dateText?: string | null): Date | null => {
    const dates = extractDatesFromSeminarText(dateText);
    if (dates.length === 0) return null;
    return dates.reduce((latest, d) => (d.getTime() > latest.getTime() ? d : latest));
};

export const startOfTodayLocal = (): Date => {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), now.getDate());
};

/** true, wenn das Seminar/Event nach seinem Enddatum abgelaufen ist. */
export const isSeminarDateExpired = (dateText?: string | null, today: Date = startOfTodayLocal()): boolean => {
    const end = parseSeminarEndDate(dateText);
    if (!end) return false;
    return end.getTime() < today.getTime();
};

export const toIsoDateLocal = (d: Date): string =>
    `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
